module.exports = __webpack_public_path__ + "1d8a7f191ecbffe84293f1efaa7b46ed.png";